const Pdv = () => import('./pages/Pdv.vue');
const PdvClsoeCehckout = () => import('./pages/PdvCloseCheckout.vue');

export default [
  {
    path: '/fiscal/pdv',
    name: 'Pdv',
    component: Pdv,
    meta: {
      title: 'PDV',
    },
  },
  {
    path: '/inventory/managerial/:gerencial',
    name: 'Pdv',
    component: Pdv,
    meta: {
      title: 'PDV - Pré-venda Gerencial',
    },
  },
  {
    path: '/fiscal/pdv/close-checkout',
    name: 'Pdv Close Checkout',
    component: PdvClsoeCehckout,
    meta: {
      title: 'PDV',
    },
  },
];
